module.exports = __webpack_public_path__ + "img/xiaozhishi.eafd05f3.png";